"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedButtonStyles = exports.Button = exports.transparentButtonTheme = exports.dangerousButtonTheme = exports.tertiaryButtonTheme = exports.secondaryButtonTheme = exports.primaryButtonTheme = void 0;
var tslib_1 = require("tslib");
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var kebabCase_1 = (0, tslib_1.__importDefault)(require("lodash/kebabCase"));
var React = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var test_helpers_1 = require("../../lib/test-helpers");
var colors_1 = require("../../theme/colors");
var spinner_1 = require("../spinner");
exports.primaryButtonTheme = {
    textColor: 'white',
    borderColor: colors_1.colors.brand[400],
    backgroundColor: colors_1.colors.brand[400],
    backgroundHoverColor: colors_1.colors.brand[300],
    borderHoverColor: colors_1.colors.brand[300],
    textHoverColor: 'white',
    backgroundDisabledColor: colors_1.colors.steel[200],
    borderDisabledColor: colors_1.colors.steel[200],
    textDisabledColor: 'white',
    textLoadingColor: 'white',
    focusShadowColor: "0 0 0 3px ".concat(colors_1.colors.brand[300], "70"),
};
exports.secondaryButtonTheme = {
    textColor: colors_1.colors.steel[500],
    borderColor: colors_1.colors.steel[200],
    backgroundColor: 'white',
    backgroundHoverColor: 'white',
    borderHoverColor: colors_1.colors.brand[300],
    textHoverColor: colors_1.colors.steel[500],
    backgroundDisabledColor: colors_1.colors.steel[100],
    borderDisabledColor: colors_1.colors.steel[200],
    textDisabledColor: colors_1.colors.steel[400],
    textLoadingColor: colors_1.colors.steel[500],
    focusShadowColor: "0 0 0 3px ".concat(colors_1.colors.steel[200], "40"),
};
exports.tertiaryButtonTheme = {
    textColor: colors_1.colors.steel[500],
    borderColor: colors_1.colors.brand[100],
    backgroundColor: colors_1.colors.brand[100],
    backgroundHoverColor: colors_1.colors.brand[100],
    borderHoverColor: colors_1.colors.brand[100],
    textHoverColor: colors_1.colors.steel[500],
    backgroundDisabledColor: colors_1.colors.steel[200],
    borderDisabledColor: colors_1.colors.steel[200],
    textDisabledColor: 'white',
    textLoadingColor: 'white',
    focusShadowColor: "0 0 0 3px ".concat(colors_1.colors.brand[200], "70"),
};
exports.dangerousButtonTheme = {
    textColor: 'white',
    borderColor: colors_1.colors.fire[500],
    backgroundColor: colors_1.colors.fire[500],
    backgroundHoverColor: colors_1.colors.fire[400],
    borderHoverColor: colors_1.colors.fire[400],
    textHoverColor: 'white',
    backgroundDisabledColor: colors_1.colors.steel[200],
    borderDisabledColor: colors_1.colors.steel[200],
    textDisabledColor: 'white',
    textLoadingColor: 'white',
    focusShadowColor: "0 0 0 3px ".concat(colors_1.colors.fire[300], "70"),
};
exports.transparentButtonTheme = {
    textColor: colors_1.colors.steel[500],
    borderColor: 'transparent',
    backgroundColor: 'transparent',
    backgroundHoverColor: 'transparent',
    borderHoverColor: 'transparent',
    textHoverColor: colors_1.colors.steel[500],
    backgroundDisabledColor: 'transparent',
    borderDisabledColor: 'transparent',
    textDisabledColor: colors_1.colors.steel[400],
    textLoadingColor: colors_1.colors.steel[500],
    focusShadowColor: "none",
};
function getTheme(size) {
    if (size === 'primary')
        return exports.primaryButtonTheme;
    if (size === 'tertiary')
        return exports.tertiaryButtonTheme;
    if (size === 'dangerous')
        return exports.dangerousButtonTheme;
    if (size === 'transparent')
        return exports.transparentButtonTheme;
    return exports.secondaryButtonTheme;
}
function Button(props) {
    var id = props.id, children = props.children, disabled = props.disabled, href = props.href, loading = props.loading, onClick = props.onClick, propTestId = props.testId, _a = props.size, size = _a === void 0 ? 'primary' : _a, style = props.style, target = props.target, type = props.type, _b = props.minWidth, minWidth = _b === void 0 ? 'auto' : _b, elementRef = props.elementRef, innerRef = props.innerRef;
    var testId = propTestId !== null && propTestId !== void 0 ? propTestId : (typeof children === 'string' ? (0, test_helpers_1.generateTestId)((0, kebabCase_1.default)(children.toString()), 'button') : undefined);
    var className = (0, classnames_1.default)({
        'ui-button': true,
        disabled: disabled,
        loading: loading,
        primary: size === 'primary',
        secondary: size === 'secondary',
    });
    var spinner = loading ? React.createElement(spinner_1.Spinner, { height: 40 }) : null;
    var theme = getTheme(size);
    return (React.createElement(React.Fragment, null, shouldRenderAnchor(props) ? (React.createElement(StyledAnchor, (0, tslib_1.__assign)({ minWidth: minWidth, theme: theme, id: id, "data-testid": testId, href: href, onClick: onClick, className: className, style: style, target: target }, props.htmlProps),
        spinner,
        React.createElement("span", { className: "text" }, children))) : (React.createElement(StyledButton, (0, tslib_1.__assign)({}, props.htmlProps, { minWidth: minWidth, theme: theme, id: id, "data-testid": testId, type: type, onClick: onClick, className: className, style: style, disabled: disabled || loading, ref: elementRef || innerRef }),
        spinner,
        React.createElement("span", { className: "text" }, children)))));
}
exports.Button = Button;
var sharedButtonStyles = function (theme, minWidth) { return "\n  all: initial;\n  appearance: none;\n  background-color: ".concat(theme.backgroundColor, ";\n  border-radius: 4px;\n  border: 1px solid ").concat(theme.borderColor, ";\n  box-sizing: border-box;\n  color: ").concat(theme.textColor, " !important;\n  cursor: pointer;\n  display: inline-block;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  height: 40px;\n  line-height: 38px;\n  padding: 0 32px;\n  position: relative;\n  text-decoration: none;\n  white-space: nowrap;\n  text-align: center;\n  min-width: ").concat(typeof minWidth === 'number' ? "".concat(minWidth, "px") : minWidth, ";\n\n  :focus,\n  :active {\n    outline: none;\n    text-decoration: none !important;\n  }\n  :disabled {\n    cursor: not-allowed;\n    outline: none;\n    box-shadow: none;\n  }\n\n  &.loading,\n  &.loading:active {\n    color: ").concat(theme.textLoadingColor, ";\n    cursor: wait;\n    box-shadow: none;\n  }\n  &.loading .text {\n    color: transparent;\n  }\n\n  :hover:not(:disabled) {\n    background: ").concat(theme.backgroundHoverColor, ";\n    border-color: ").concat(theme.borderHoverColor, ";\n    color: ").concat(theme.textHoverColor, ";\n    text-decoration: none !important;\n  }\n  &.disabled {\n    background-color: ").concat(theme.backgroundDisabledColor, ";\n    border-color: ").concat(theme.borderDisabledColor, ";\n    color: ").concat(theme.textDisabledColor, ";\n  }\n  :focus:not(:disabled),\n  :active:not(:disabled) {\n    box-shadow: ").concat(theme.focusShadowColor, ";\n  }\n\n  &.secondary.disabled {\n    opacity: 0.6;\n  }\n"); };
exports.sharedButtonStyles = sharedButtonStyles;
var StyledButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var minWidth = _a.minWidth, theme = _a.theme;
    return (0, exports.sharedButtonStyles)(theme, minWidth);
});
var StyledAnchor = styled_components_1.default.a(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var minWidth = _a.minWidth, theme = _a.theme;
    return (0, exports.sharedButtonStyles)(theme, minWidth);
});
var shouldRenderAnchor = function (props) {
    return props.href && !props.disabled;
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map